
import _, { cloneDeep } from 'lodash-es'

export default {
  data() {
    return {
      hoverElm: null,
      activeElm: null
    }
  },
  computed: {

  },
  async mounted() {
    document.addEventListener('mousemove', (event) => {
      const hoverElms = document.elementsFromPoint(event.clientX, event.clientY);
      const isEditorElm = hoverElms.some(elm => elm.dataset.jrType && elm.dataset.jrType === 'designer');
      if (isEditorElm || this.$store.state.editor.canHover === false) {
        return;
      }
      
      const hoverSectionElm = hoverElms.find(elm => elm.dataset.jrType && elm.dataset.jrType === 'section');
      const hoverSectionId = hoverSectionElm && hoverSectionElm.dataset.jrSectionId;
      if(hoverSectionId) {
        const sectionBox = {
          show: true,
          sectionId: hoverSectionId,
          rect: this.getBoxRect(hoverSectionElm)
        }
        this.$store.commit('editor/setSectionBox', { box: sectionBox });
      } else {
        this.$store.commit('editor/hideSectionBox');
      }

      const hoverEditableElm = hoverElms.find(elm => elm.dataset.jrEditable);
      if(hoverEditableElm && hoverEditableElm != this.activeElm) {
        const hoverBox = {
          show: true,
          rect: this.getBoxRect(hoverEditableElm),
          type: hoverEditableElm.dataset.jrType ? hoverEditableElm.dataset.jrType : 'editable',
          sectionId: hoverSectionId,
          bind: hoverEditableElm.dataset.jrBind
        };
        this.$store.commit('editor/setHoverBox', { box: hoverBox });
        this.hoverElm = hoverEditableElm;
      } else {
        this.$store.commit('editor/hideHoverBox');
        this.hoverElm = null;
      }
    });
  },
  watch: {

  },
  methods: {
    getBoxRect(elm) {
      const rect = elm.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft,
        width: rect.width,
        height: rect.height
      }
    },
    handleHoverBoxClick() {
      this.$store.commit('editor/setActiveBox', { box: cloneDeep(this.$store.state.editor.hoverBox) });
      this.activeElm = this.hoverElm;
      this.$store.commit('editor/hideHoverBox');
      
      // 点击元素之后才记录激活的sectionId
      this.$store.commit('editor/setActiveSectionId', { id: this.$store.state.editor.sectionBox.sectionId });
    },
    activateParentList(parentListElm, sectionId) {
      const activeBox = {
        show: true,
        rect: this.getBoxRect(parentListElm),
        type: 'list',
        sectionId,
        bind: parentListElm.dataset.jrBind
      };
      this.$store.commit('editor/setActiveBox', { box: activeBox });
      this.activeElm = parentListElm;
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('editor/hideSectionBox');
    this.$store.commit('editor/hideHoverBox');
    this.$store.commit('editor/hideActiveBox');
    next();
  }
}
